import docsUserAgent from '@tencent/docs-user-agent';

/**
 * 是否是pc
 * @param {user agent} ua
 */
export function isPc(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return !/SymbianOS|iphone|android|iPad/i.test(ua);
}

/**
 * 是否是移动端, ipad 包含在移动端, 添加对Android pad的判断
 * @param {user agent} ua
 */
export function isMobile(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /mobile|android/i.test(ua);
}

/**
 * 是否是 iPad
 * @param {user agent} ua
 */
export function isIPad(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /(ipad)/i.test(ua);
}


/**
 * 是否是 iPad Pro 10.5" 尺寸834*1194
 * @param {user agent} ua
 */
export function isIPadPro(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    const isPro = /(ipad)/i.test(ua) && (window.screen.width >= 1194 || window.screen.height >= 1194);
    return isPro;
}
/**
 * 是否是 Android Pad
 * @param {user agent} ua
 */
export function isAndroidPad(ua?) {
    let innerUA = ua;
    if (typeof (innerUA) === 'undefined') {
        innerUA = window.navigator.userAgent;
    }
    const containsAndroid = /(android)/i.test(innerUA);
    const containsMobile = /mobile/i.test(innerUA);
    return containsAndroid && !containsMobile;
}

/**
 * 是否是 mac 电脑
 * @param {user agent} ua
 */
export function isMac(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return !isMobile(ua) && /Mac OS X/i.test(ua);
}

/**
 * 是否是安卓平台
 * @param {user agent} ua
 */
export function isAndroid(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /android|adr/i.test(ua);
}

/**
 * 是否是 iOS 平台
 * @param {user agent} ua
 */
export function isIOS(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /(iphone|ipad|ipod)/i.test(ua);
}

/**
 * 判断是否是在 windows store 的 uwp 软件上运行
 * @param {user agent} ua
 */
export function isWindowStore(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /MSAppHost/i.test(ua);
}

/**
 * 判断是否是 windows 平台
 * @param {user agent} ua
 */
export function isWindows(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /Windows/i.test(ua);
}

/**
 * 是不是 PC 上的 QQ 浏览器, 会自动排除 PC QQ
 * @param {user agent} ua
 */
export function isPCQQBrowser(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return !isMobile(ua)
        && /QQBrowser/i.test(ua)
        && !/QBCore/i.test(ua);
}

/**
 * 是不是移动端上的 QQ 浏览器, 会自动排除安卓QQ/tim/微信/企业微信
 * @param {user agent} ua
 */
export function isMobileQQBrowser(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return isMobile(ua)
        && /MQQBrowser/i.test(ua)
        && !/TBS/i.test(ua);
}

/**
 * 是否是 QQ 浏览器
 * @param {user agent} ua
 */
export function isQQBrowser(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return isMobile(ua)
        ? isMobileQQBrowser(ua)
        : isPCQQBrowser(ua);
}

/**
 * 是否是腾讯文档的独立 app
 * @param {user agent} ua
 */
export function isTencentDocApp(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /TencentDocs/i.test(ua);
}

/**
 * 是否是腾讯文档桌面 app
 * @param {*} ua user-agent
 */
export function isTencentDocDesktopApp(ua = window.navigator.userAgent) {
    return /TDAppDesktop/i.test(ua);
}

/**
 * 是否是微信小程序
 * @param {user agent} ua
 */
export function isWxMiniProgram(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    // 企业微信 iOS 比较特殊，UA 中没有小程序的字样，只能通过全局 __wxjs_environment 来判断,在QQ小程序中新建进入的详情页也会带上__wxjs_environment=miniprogram
    const wxUrlContainStr = '__wxjs_environment=miniprogram';
    // (/miniprogram|miniapp(?!enable)/i.test(ua) || window.location.href.indexOf(wxUrlContainStr) > -1)代表
    // 是否是（微信/企业微信或 QQ/TIM）的小程序 webview
    return /MicroMessenger/i.test(ua) && (/miniprogram|miniapp(?!enable)/i.test(ua) || window.location.href.indexOf(wxUrlContainStr) > -1);
}

export function isQQMiniProgram(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    const qqUrlContainStr = '__wxjs_environment=qqminiprogram';
    return window.location.href.indexOf(qqUrlContainStr) > -1
    || (/QQ/i.test(ua) && /MiniApp/i.test(ua) && !/MiniAppEnable/i.test(ua))
    || (/QQ/i.test(ua) && /miniProgram/i.test(ua));
}

export function isQQH5() {
    return isQQ() && !isQQMiniProgram();
}

export function isH5() {
    return (isQQ() && !isQQMiniProgram()) || (isWeChat() && !isWxMiniProgram());
}

export function isMiniProgram() {
    return (isWxMiniProgram() || isQQMiniProgram());
}

/**
 * 是否是企业微信
 * @param {user agent} ua
 */
export function isWxWork(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /(wxwork)/i.test(ua);
}
/**
 * 是否是CEF内核的企微
 * @param {user agent} ua
 */
export function isCEFWxWork(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /(WeComCEF)/i.test(ua);
}

/**
 * 是否是微信, 自动排除企业微信和微信小程序
 * @param {user agent} ua
 */
export function isWeChat(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /MicroMessenger/i.test(ua) && !isWxWork(ua) && !isWxMiniProgram();
}

/**
 * 是否是 tim
 * @param {user agent} ua
 */
export function isTim(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /TIM/i.test(ua);
}

/**
 * 是否是 qq, 会自动排除腾讯文档/企业微信/微信/qq浏览器/tim
 * @param {user agent} ua
 */
export function isQQ(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /QQ/i.test(ua)
        && !isTencentDocApp(ua)
        && !isWxWork(ua)
        && !isWeChat(ua)
        && !isQQBrowser(ua)
        && !isTim(ua);
}

/**
 * 是否是 tim 或者 qq
 * @param {user agent} ua
 */
export function isTimOrQQ(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return isTim(ua) || isQQ(ua);
}

export const isTimQQ = isTimOrQQ;

/**
 * 属于 tim 或者泛 qq 家族
 * @param {user agent} ua
 */
export function isTimOrQQFamily(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return isTim() || /QQ/i.test(ua);
}

/**
 * 是否是 pc 端的 tim
 * @param {user agent} ua
 */
export function isPCTim(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /QBCore/i.test(ua) && /TIM2.0/i.test(ua);
}

/**
 * 是否是 pc 端的 微信浏览器
 * @param {user agent} ua
 */
export function isPCWechat(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /(windows)/.test(ua) && /(micromessenger)/.test(ua);
}

/**
 *
 * @param {user agent} ua
 */
export function isQQFamily(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /QQ/i.test(ua);
}

/**
 * 判断是否是 pc 客户端
 * @param {user agent} ua
 */
export function isPCTencentDocApp(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    return /TxDocsPC/i.test(ua);
}

/**
 * 判断是否是 ipad app 客户端
 * @param {user agent} ua
 */
export function isIpadAndTencentDocApp(ua?) {
    return isIPad(ua) && isTencentDocApp(ua);
}

/**
 * 判断是否是iPhoneX及其之后的版本
 */
export function checkIsLargeThanIphoneX() {
    // iPhone 12 mini尺寸为360x780
    const checkIsLargeThanIphoneX = /iphone/gi.test(window.navigator.userAgent) && (window.screen.height >= 780 || window.screen.width >= 780);
    return checkIsLargeThanIphoneX;
}

/**
 * 判断是否是iPhoneX
 */
export function checkIsIphoneXSMax() {
    const isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && ((window.screen.width === 414 && window.screen.height === 896) || (window.screen.width === 896 && window.screen.height === 414));
    return isIPhoneXSMax;
}

export function checkIsIphoneXR() {
    const isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && ((window.screen.width === 414 && window.screen.height === 896) || (window.screen.width === 896 && window.screen.height === 414));
    return isIPhoneXR;
}

export function checkIsIphoneX() {
    if (/iphone x/gi.test(window.navigator.userAgent)) {
        return true;
    }
    // 在某些webview中（tim/2.3.0.401/iphonexr) 下 safe-area 会失效
    // iPhone X、iPhone XS
    const isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && ((window.screen.width === 812 && window.screen.height === 375) || (window.screen.width === 375 && window.screen.height === 812));
    // iPhone XS Max
    const isIPhoneXSMax = checkIsIphoneXSMax();
    // iPhone XR
    const isIPhoneXR = checkIsIphoneXR();
    return isIPhoneX || isIPhoneXSMax || isIPhoneXR;
}

export function checkIsP20() {
    if (/EML-AL00/gi.test(window.navigator.userAgent) || /CLT-AL01/gi.test(window.navigator.userAgent)) {
        return true;
    }
    return false;
}

export function versionToNum(version) {
    const nums = version.split('.');
    let sum = 0;
    if (nums.length >= 1) {
        sum = parseInt(nums[0], 10) * 10000;
        if (nums.length >= 2) {
            sum += parseInt(nums[1], 10) * 100;
            if (nums.length >= 3) {
                sum += parseInt(nums[2], 10);
            }
        }
    }
    return sum;
}

export function checkIsNarrowScreen() {
    return window.screen.width <= 375;
}

export function checkIsMiddleScreen() {
    return window.screen.width > 375 && window.screen.width <= 400;
}

export function checkIsWideScreen() {
    return window.screen.width > 400;
}

function genMTIMVer() {
    const { userAgent } = window.navigator;
    if (isMobile()) {
        const reg = new RegExp('TIM/([0-9])+(.[0-9])+', 'i');
        const result = reg.exec(userAgent);
        if (!result?.[0]) return 0;
        const [version] = result;
        return version.split('/')[1];
    }
    return 0;
}

export function genMQQVer() {
    const { userAgent } = window.navigator;
    if (isMobile() && (userAgent.indexOf('TIM') === -1) && (userAgent.indexOf('tim') === -1)) {
        const reg = new RegExp('QQ/([0-9])+(.[0-9])+', 'i');
        const result = reg.exec(userAgent);
        if (!result?.[0]) return 0;
        const [version] = result;
        return version.split('/')[1];
    }
    return 0;
}

/**
 * 是不是移动端上的 QQ 浏览器, 会自动排除安卓QQ/tim/微信/企业微信
 */
export function isWideScreenDevice() {
    if (isWxWork() && isIPad()) {
        return window.innerWidth > 550;
    }
    return window.screen.width > 550;
}

class UAUtil {
    private MQQVer: string|number;
    private MTIMVer: string|number;
    public constructor() {
        this.MTIMVer = genMTIMVer();
        this.MQQVer = genMQQVer();
    }

    public MQQLargerOrEqual(otherVer) {
        const result = this.compareVersion(this.MQQVer, otherVer);
        if (((typeof result) === 'number') && (result as number) >= 0) {
            return true;
        }
        return false;
    }

    public MTIMLargerOrEqual(otherVer) {
        const result = this.compareVersion(this.MTIMVer, otherVer);
        if (((typeof result) === 'number') && (result as number) >= 0) {
            return true;
        }
        return false;
    }

    /*
    * 传入格式必须是字符串 xx.x.x  x位数不限
    * 返回 -1 version1 < version2
    * 返回 0 version1 = version2
    * 返回 1 version1 > verison2
    * 返回 undefine 数据错误
    */
    public compareVersion(version1, version2) {
        if (!this.checkParamValid(version1, version2)) {
            return undefined;
        }
        const numsVersion1 = version1.split('.');
        const numsVersion2 = version2.split('.');
        let result = 0;
        const commonLength = Math.max(numsVersion1.length, numsVersion2.length);
        for (let i = 0; i < commonLength; i++) {
            const str1 = (numsVersion1.length) > i ? numsVersion1[i] : '0';
            const str2 = (numsVersion2.length) > i ? numsVersion2[i] : '0';
            const num1 = parseInt(str1, 10);
            const num2 = parseInt(str2, 10);
            if (!Number.isNaN(num1) && !Number.isNaN(num2)) {
                if (num1 !== num2) {
                    result = num1 > num2 ? 1 : -1;
                    break;
                }
            } else {
                return undefined;
            }
        }
        return result;
    }

    public checkParamValid(version1, version2) {
        if ((typeof version1) !== 'string' || (typeof version2) !== 'string') {
            return false;
        }
        return !(version1.length <= 0 || version2.length <= 0);
    }
}

export const uaUtil = new UAUtil();

const ua = window.navigator.userAgent;

/**
 * 获取独立app的版本
 */
function getAppVer() {
    if (isMobile() && !isTim()) {
        const reg = new RegExp('TencentDocs/(\\d+\\.)+\\d+', 'i');
        const result = reg.exec(ua);
        if (!result?.[0]) return 0;
        const [version] = result;
        return version.split('/')[1];
    }
    return 0;
}

/**
 * 判断独立app的版本号是否大于等于指定版本
 */
export function isAppLargerOrEqual(otherVer) {
    const currVer = getAppVer();
    const result = uaUtil.compareVersion(currVer, otherVer);
    if (((typeof result) === 'number') && (result as number) >= 0) {
        return true;
    }
    return false;
}

/**
 * 判断独立app的版本号是否大于指定版本
 */
export function isAppVersionGreaterThan(otherVer) {
    const currVer = getAppVer();
    const result = uaUtil.compareVersion(currVer, otherVer);
    if (((typeof result) === 'number') && (result as number) > 0) {
        return true;
    }
    return false;
}

/**
 * 获取ios系统版本
 */
export function getiOSVer(ua = window.navigator.userAgent) {
    const reg = new RegExp('CPU( iPhone)? OS ([0-9]+_{1}[0-9]+(_{1}[0-9]+)*) like', 'i');
    const result = reg.exec(ua);
    if (!result?.[2]) return 0;
    const [, , version] = result;
    return versionToNum(version.replace(/_/g, '.'));
}

/**
 * 判断ios的版本号是否大于等于指定版本
 */
export function iosVerLargerOrEqual(otherVer) {
    const currVer = getiOSVer();
    return currVer === 0 ? false : currVer >= versionToNum(otherVer);
}

/**
 *
 * @param {*} bIsApp 是否是APP平台
 * @param {*} bIsARD 是否是安卓
 * @param {*} bIsIOS 是否是iOS
 * @param {*} bIsIpad 是否是iPAD
 * @param {*} currVer 当前APP版本
 * @param {*} ardVer 安卓平台开始支持本地工具栏的版本
 * @param {*} iOSVer iOS平台开始支持本地工具栏的版本
 */
export function isSupportNativeToolbarInner(bIsApp, bIsARD, bIsIOS, bIsIpad, currVer, ardVer, iOSVer) {
    let compareVer;
    if (bIsApp) {
        if (bIsARD) {
            compareVer = ardVer;
        } else if (bIsIOS || bIsIpad) {
            compareVer = iOSVer;
        } else {
            return false;
        }
        const result = uaUtil.compareVersion(currVer, compareVer);
        if (((typeof result) === 'number') && (result as number) >= 0) {
            return true;
        }
    }
    return false;
}

// 是否支持native工具栏
function isSupportNativeToolbar() {
    const bIsApp = isTencentDocApp();
    const bIsAZ = isAndroid();
    const bIsIOS = isIOS();
    const bIsIPad = isIPad();
    const currVer = getAppVer();
    const ANDROIDVER = '113.0.1'; // 待客户端发版后更新
    const IOSPADVER = '113.0.1';  // 待客户端发版后更新

    return isSupportNativeToolbarInner(bIsApp, bIsAZ, bIsIOS, bIsIPad, currVer, ANDROIDVER, IOSPADVER);
}

// 获取PPT 标定文档的字符串
function getDocUniqueUrl() {
    const match = window.location.href.match(`(http:|https:)?//${window.hostname}/slide/([a-zA-Z0-9]*).*`);
    let docKey = 'slide';
    if (match) {
        // eslint-disable-next-line
        docKey = match[2];
    }
    return docKey;
}

export function isIosWeChatOrIpadSafari(ua?) {
    if (ua === void 0) {
        // eslint-disable-next-line
        ua = window.navigator.userAgent;
    }
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    return (isIOS() && (isWxMiniProgram() || isWeChat()))
    || (isIPad() && isSafari);
}

/**
 * pad窄屛
*/
export function isPadNarrowScreen() {
    return (isIPad() || isAndroidPad()) && !isWideScreenDevice();
}

/** pc 场景下，是否可以正常使用 `window.open` */
export function canIUseWindowOpenInPc() {
    // 企微webview 打开后父子窗口无法通信(子窗口 window.opener === null)
    return !docsUserAgent.isWxWork
        // 微信webview、微信小程序 表现与移动端相似，即会在当前窗口跳转
        && !docsUserAgent.isWeChat && !docsUserAgent.isWxMiniProgram;
}

/** 是否是融合会议 */
export function isWeworkMeeting(ua = window.navigator.userAgent) {
    return /(c_meeting_wework_sdk\/1)/i.test(ua);
}

/**
 * UA判断工具
 */
export const browser = {
    /**
     * 是否是移动端, ipad 包含在移动端
     */
    isMobile: isMobile(),
    /**
     * 是否是 iPad
     */
    isIPad: isIPad(),
    /**
     * 是否是 Android Pad
     */
    isAndroidPad: isAndroidPad(),
    /**
     * 是否是 Pad(双平台)
     */
    isPad: isIPad() || isAndroidPad(),
    /**
     * 是否是 mac 电脑
     */
    isMac: isMac(),
    /**
     * 是否是Windows平台
     */
    isWindows: isWindows(),
    /**
     * 是否是安卓平台
     */
    isAndroid: isAndroid(),
    /**
     * 是否是 iOS 平台
     */
    isIOS: isIOS(),
    /**
     * 判断是否是在 windows store 的 uwp 软件上运行
     */
    isWindowStore: isWindowStore(),
    /**
     * 是不是 PC 上的 QQ 浏览器, 会自动排除 PC QQ
     */
    isPCQQBrowser: isPCQQBrowser(),
    /**
     * 是不是移动端上的 QQ 浏览器, 会自动排除安卓QQ/tim/微信/企业微信
     */
    isMobileQQBrowser: isMobileQQBrowser(),
    /**
     * 是否是 QQ 浏览器
     */
    isQQBrowser: isQQBrowser(),
    /**
     * 是否是腾讯文档的独立 app
     */
    isTencentDocApp: isTencentDocApp(),
    /**
     * 是否是腾讯文档桌面 app
     */
    isTencentDocDesktopApp: isTencentDocDesktopApp(),
    /**
     * 是否是微信小程序
     */
    isWxMiniProgram: isWxMiniProgram(),
    /**
     * 是否是window微信小程序
     */
    isWindowWxMiniProgram: isWxMiniProgram() && isWindows(),
    /**
     * 是否是QQ小程序
     */
    isQQMiniProgram: isQQMiniProgram(),
    /**
     * 是否是小程序
     */
    isMiniProgram: isMiniProgram(),
    /**
     * 是否是企业微信
     */
    isWxWork: isWxWork(),
    /**
     * 是否是CEF内核的企微
     */
    isCEFWxWork: isCEFWxWork(),
    /**
     * 是否是微信, 自动排除企业微信和微信小程序
     */
    isWeChat: isWeChat(),
    /**
     * 是否是 tim
     */
    isTim: isTim(),
    /**
     * 是否是 qq, 会自动排除腾讯文档/企业微信/微信/qq浏览器/tim
     */
    isQQ: isQQ(),
    /**
     * 是否是 tim 或者 qq
     */
    isTimOrQQ: isTimOrQQ(),
    /**
     * 是否是 tim 或者 qq
     */
    isTimQQ: isTimQQ(),
    /**
     * 属于 tim 或者泛 qq 家族
     */
    isTimOrQQFamily: isTimOrQQFamily(),
    /**
     * 是否是 pc 端的 微信浏览器
     */
    isPCWechat: isPCWechat(),
    /**
     * 是否是 pc 端的 tim
     */
    isPCTim: isPCTim(),
    isQQFamily: isQQFamily(),
    /**
     * 判断是否是 pc 客户端
     */
    isPCTencentDocApp: isPCTencentDocApp(),
    /**
     * 判断是否是APP内嵌入的
     */
    isWithinApp: isWxWork() || isTencentDocApp() || isTimOrQQ() || isMiniProgram(),
    /**
     * 是否是Opera
     */
    isOpera: /Opera/i.test(ua),
    /**
     * 是否是Firefox
     */
    isFirefox: /Firefox/i.test(ua),
    /**
     * 是否是Chrome
     */
    isChrome: /Chrome/i.test(ua),
    /**
     * 是否是Safari
     */
    isSafari: /^((?!chrome|android).)*safari/i.test(ua),
    /**
     * 是否是IE
     */
    isIE: /compatible/i.test(ua) && /MSIE/i.test(ua) && !/Opera/i.test(ua),
    /**
     * 是否是Edge
     */
    isEdge: /Edge/.test(ua),
    /**
     * 判断是否是iPhoneX及其之后的版本
     */
    checkIsLargeThanIphoneX: checkIsLargeThanIphoneX(),
    /**
     * 是否是iPhoneX
     */
    checkIsIphoneX: checkIsIphoneX(),
    /**
     * 是否是刘海屏
     */
    checkHasBang: checkIsIphoneX() || checkIsP20(),
    /**
     * 是否是超大的宽屏，这里必须实时去取，因为中间可能有变更
     */
    get isWideScreenDevice() {
        return isWideScreenDevice();
    },
    /**
     * 是否支持本地工具栏
     */
    isSupportNativeToolbar: isSupportNativeToolbar(),
    /**
     * 得到PPT特定文档的标记字段
     */
    getDocUniqueUrl: getDocUniqueUrl(),
    /**
     * 腾讯文档ipad app
     */
    isIpadAndTencentDocApp: isIpadAndTencentDocApp(),
    /**
     * 是否是ipad Pro
     */
    isIPadPro: isIPadPro(),
    /**
     * 是否是ios微信或者ipad safari
     */
    isIosWeChatOrIpadSafari: isIosWeChatOrIpadSafari(),
    /**
     * 是否是qq h5
     */
    isQQH5: isQQH5(),
    /**
     * 是否是全端h5
     */
    isH5: isH5(),
    /**
     * 是否是pc
     */
    isPc: isPc(),
    /**
     * 移动端胶囊态工具栏判断屏幕尺寸
     */
    isNarrowScreen: checkIsNarrowScreen(),
    isMiddleScreen: checkIsMiddleScreen(),
    isWideScreen: checkIsWideScreen(),
    /*
     * 是否是pad窄屛，实时去取，因为中间可能有变更
     */
    get isPadNarrowScreen() {
        return isPadNarrowScreen();
    },
    /**
     * 是否是融合会议
     */
    isWeworkMeeting: isWeworkMeeting(),
};
